(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renata-page-contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBookingDate(input) {
      if (input.dataset.bookingDateBound === 'true') return;
      input.dataset.bookingDateBound = 'true';

      var closed = (input.dataset.closedDays || '')
        .split(',')
        .filter(function (value) { return value !== ''; })
        .map(Number);
      var message = input.dataset.closedMessage || 'Bookings are not available on that day.';
      var errorEl = input.parentNode.querySelector('[data-booking-date-error]');

      function validate() {
        input.setCustomValidity('');
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }

        if (!input.value) return;

        var parts = input.value.split('-');
        if (parts.length !== 3) return;

        // Construct in local time so the weekday matches what the user picked.
        var picked = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
        if (isNaN(picked.getTime())) return;

        if (closed.indexOf(picked.getDay()) !== -1) {
          input.setCustomValidity(message);
          if (errorEl) {
            errorEl.textContent = message;
            errorEl.hidden = false;
          }
        }
      }

      input.addEventListener('input', validate);
      input.addEventListener('change', validate);
      input.addEventListener('blur', validate);
      validate();
    }

    function init() {
      document.querySelectorAll('[data-booking-date]').forEach(initBookingDate);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
